export default __webpack_public_path__ + "static/media/what-we-do-background-rectangle.df3be337.svg";